module.exports = __webpack_public_path__ + "media/images/landing/bg/icons-svg-22853a2e6e95bd26e1dbafddb03abb17.svg";